import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import * as Yup from "yup";
import cogoToast from "cogo-toast";
import CheckBoxInput from "../../../Common/components/checkbox-input";
import { SearchIcon, UserIcon } from "../../../../util/Icons";

import { Card, CardBody, CardFooter, CardHeader } from "../../../../../_metronic/_partials/controls";
import { useExemptAccountsMutation, useSearchAccountsQuery } from "../../../../../redux/apiSlice";
import { useSelector } from "react-redux";


export const SearchAccount = ({ userGroup, setFieldValue }) => {
    const [
        exemptAccounts
    ] = useExemptAccountsMutation()
    const adminUser = useSelector(state => state.auth.user);

    const [query, setQuery] = useState('');

    const { data: searchedAccounts, isLoading } = useSearchAccountsQuery(query);

    const handleSearch = (e) => {
        const inputValue = e.target.value;
        setQuery(inputValue);

    };


    const toggleAccountSelected = (account, setFieldValue, selectedAccounts) => {
        const id = account.accountId;
        if (selectedAccounts[id]) {
            const newAccounts = { ...selectedAccounts };
            delete newAccounts[id];
            setFieldValue("accounts", newAccounts);
        } else {
            setFieldValue("accounts", { ...selectedAccounts, [id]: account });
        }
    };


    const AccountsList = ({ accounts, selectedAccounts, setFieldValue }) =>
        accounts?.map((account) => (
            <div className="mb-3" key={account.accountId}>
                <CheckBoxInput
                    name={`accounts[${account.accountId}]`}
                    onChange={() => toggleAccountSelected(account, setFieldValue, selectedAccounts)}
                    checked={selectedAccounts[account.accountId]}
                    value={account}
                >
                    <div className="d-flex align-items-center">
                        <div
                            style={{
                                height: "28px",
                                width: "28px",
                            }}
                            className="mr-3 border rounded-circle bg-black d-flex align-items-center justify-content-center"
                        >
                            <UserIcon size="18px" />
                        </div>
                        <div className="col px-0 flex-column align-items-start">
                            <div>{account.accountId}</div>
                            <div>{account.accountNumber.substr(0, 20)}</div>

                        </div>
                    </div>
                </CheckBoxInput>
            </div>
        ));

    return (
        <Formik
            initialValues={{
                accounts: [],
                fields: {
                    maintenanceBillExempted: true,
                },
                userGroup: "trove",
            }}
            validationSchema={Yup.object({
                accounts: Yup.object()
                    .test('accounts length', 'At least one account must be selected', accounts => {
                        const keys = Object.keys(accounts);
                        return keys.length > 0;
                    })
            })}
            onSubmit={async (values) => {
                try {
                    const accounts = Object.keys(values.accounts || {});

                    await exemptAccounts({
                        accounts: accounts,
                        fields: values.fields,
                        userGroup: values.userGroup
                    })
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Accounts Exemption Initiated Successfully");
                        })
                        .catch((error) => {
                            console.error("Error initiating accounts exemption:", error);
                            cogoToast.error("Failed to initiate accounts exemption");
                        });
                } catch (error) {
                    cogoToast.error("Failed to submit the form");
                }
            }}

        >
            {({ isValid, values, setFieldValue }) => {

                return (
                    <>
                        <Form className="h-100">
                            <Card className="h-100 mb-0">
                                <CardHeader title={`Exempt Accounts`}>
                                </CardHeader>
                                <CardBody className="h-100 d-flex flex-column">
                                    <h5>Select Accounts</h5>
                                    <FormLayout.Row>
                                        <div className="col">
                                            <div className="d-flex mb-6">
                                                <div className="input-icon h-40px">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-lg form-control-solid h-40px"
                                                        placeholder="Search Accounts"
                                                        autoComplete="off"
                                                        onInput={handleSearch}
                                                    />
                                                    <span className="svg-icon svg-icon-lg">
                                                        <SearchIcon />
                                                    </span>
                                                </div>
                                            </div>
                                            {isLoading ? (
                                                <div className="text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <AccountsList accounts={searchedAccounts} selectedAccounts={values.accounts} setFieldValue={setFieldValue} />
                                                </div>
                                            )}
                                        </div>
                                        <div className="col">
                                            <div className="mb-10 h3 font-weight-bold text-dark">Selected Accounts</div>
                                            <div className="col">
                                                <AccountsList accounts={Object.values(values.accounts)} selectedAccounts={values.accounts} setFieldValue={setFieldValue} />
                                            </div>

                                        </div>
                                    </FormLayout.Row>

                                </CardBody>
                                <CardFooter>
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-elevate px-4"
                                        disabled={!isValid}
                                    >
                                        Exempt Accounts
                                    </button>
                                </CardFooter>
                            </Card>
                        </Form>
                    </>
                );
            }}
        </Formik>

    );
};